export const ONE_SECOND = 1000;
export const QUARTER_SECOND = ONE_SECOND / 4;
export const FIVE_SECONDS = ONE_SECOND * 5;
export const TEN_SECONDS = ONE_SECOND * 10;
export const FIFTEEN_SECONDS = ONE_SECOND * 15;
export const TWENTY_SECONDS = ONE_SECOND * 20;
export const THIRTY_SECONDS = ONE_SECOND * 30;
export const ONE_MINUTE = ONE_SECOND * 60;
export const ONE_HOUR = ONE_MINUTE * 60;
export const ONE_DAY = ONE_HOUR * 24;
export const ONE_WEEK = ONE_DAY * 7;
export const ONE_YEAR = ONE_DAY * 365;
